import React, { Component } from 'react';
import { isNil } from 'lodash';

import { QUARANTINE_SAMPLES_PAGINATED } from '../../../constants/paginationEntitiesTypes';
import { DEFAULT_PAGE_SIZE } from 'js/constants/paginationConstants';

import QuarantineSampleListView from './QuarantineSampleListView';
import Typography from 'new/elements/TypographySupport';

class QuarantineSamplesView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      triggerDataFetch: true,
      prevId: !isNil(props.data) && !isNil(props.data.id) ? props.data.id : null,
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.data.id !== state.prevId) {
      return {
        triggerDataFetch: true,
        prevId: props.data.id,
      };
    }

    return null;
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (this.state.triggerDataFetch === true ||
        this.props.data.id !== prevProps.data.id ||
        this.props.resourceType !== prevProps.resourceType) &&
      !this.props.preventRequest
    ) {
      this.loadData();
    }
  }

  componentWillUnmount() {
    const { data, resourceType } = this.props;

    let fetchResourceId = data ? data.id : null;
    let fetchResourceType = resourceType;

    this.props.clearPaginatedResource(
      QUARANTINE_SAMPLES_PAGINATED,
      fetchResourceType,
      fetchResourceId,
    );
  }

  loadData = (filters = { page: 1, per_page: DEFAULT_PAGE_SIZE }) => {
    const { data, resourceType, fetchResourceQuarantineSamples } = this.props;
    let fetchResourceId = data ? data.id : null;
    let fetchResourceType = resourceType;

    if (!fetchResourceId) {
      return;
    }

    if (this.state.triggerDataFetch === true) {
      this.setState({
        triggerDataFetch: false,
      });
    }

    fetchResourceQuarantineSamples(fetchResourceId, fetchResourceType, filters, 'time');
  };

  render() {
    const { isLoading, samples, resourceType } = this.props;

    return (
      <section>
        {' '}
        <div className="sample-description">
          <Typography variant="body3">
            Recent error samples in the last 24 hours. These are records that failed to pass through
            this stage of the flow.
          </Typography>
        </div>
        <QuarantineSampleListView
          resourceId={this.props.data?.id}
          samples={samples}
          loading={isLoading}
          resourceType={resourceType}
        />
      </section>
    );
  }
}

export default QuarantineSamplesView;
